"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tdContent = exports.td = void 0;

var _emotion = require("emotion");

var td =
/*#__PURE__*/
(0, _emotion.css)("padding:18px 10px;&:first-child{padding-left:10px;}font-size:14px;box-sizing:border-box;");
exports.td = td;
var tdContent =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:row;align-items:center;");
exports.tdContent = tdContent;